<a (click)="home()">
    <mat-icon>home</mat-icon>
</a>
